module.exports = __webpack_public_path__ + "static/img/fany-nb.0a9f853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fany-nb.png
// module id = 208
// module chunks = 0